import './header-tracking';

import { hideSectionsOnBacklink } from '@/modules/misc/common/hideSectionsOnBacklink.js';
import initMosaicGallery from '@/modules/misc/common/mosaic-gallery';
import { initRoomHighlights } from '@/modules/public/room/dependencies/roompage.highlights';
import initMobileSlider from '@/modules/public/venuepage/mobileSlider.js';
import initReviewsModal from '@/modules/public/venuepage/reviewsModal';
import {
  clearOldNavigationInteractionsEntries,
  tryMarkingRoomAsExternallyClicked,
} from '@/services/navigation-tracker';
import { clearOldSimilarRoomsInteractionsEntries } from '@/services/room-interactions-tracker';
import { clearOldVenuePageInteractionsEntries } from '@/services/venuepage-interactions-tracker';
import { WISHLIST_LOCAL_STORAGE_KEY } from '@/services/wishlist';

import initMosaicLazyLoading from '../../components/mosaic-lazyloading';
import { init as initThe3dTourLinks } from './roompage.3d-tour';
import { init as initHeader } from './roompage.header.js';
import { init as initMap } from './roompage.map.js';
import { init as initPricing } from './roompage.pricing.js';
import { sortRoomPageSections } from './roompage.sort-sections.js';

let mosaicModal = null;
let historyHelper = null;

sortRoomPageSections();
hideSectionsOnBacklink();

const initGallery = () => {
  const galleryEl = document.querySelector('#gallery--mixed-source');
  const images = JSON.parse(galleryEl.dataset.galleryItems);

  if (window.innerWidth <= 700) {
    images.forEach(image => {
      image.src = image.srcMobile;
    });
  }

  const lightbox = initMosaicGallery(images);

  lightbox.on('close', () => {
    if (window.location.hash === '#lightbox-gallery') {
      historyHelper.back();
    }
  });

  lightbox.on('afterInit', () => {
    // https://github.com/dimsemenov/PhotoSwipe/issues/2027#issuecomment-1608768886
    document.querySelector('.pswp__container').addEventListener('touchstart', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'back',
      order: 1,
      isButton: false,
      appendTo: 'root',
      html: '<span class="pswp__back__label">Gallery</span>',
      onClick: () => {
        $('.modal.fade').off('show.bs.modal hide.bs.modal'); // disable modal history, it conflicts with historyHelper
        $('.modal.fade').data('modal-history-registered', 0);
        historyHelper.back();
      },
    });
    lightbox.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 2,
      isButton: false,
      appendTo: 'root',
      html: '',
      onInit: (el) => {
        lightbox.pswp.on('change', () => {
          el.innerHTML = lightbox.pswp.currSlide.data.caption;
        });
      },
    });

    lightbox.pswp.ui.registerElement({
      name: 'close-gallery',
      order: 3,
      isButton: false,
      appendTo: 'root',
      html: '<span class="pswp__close__label">Close</span>',
      onClick: () => {
        window.history.go(-2);
      },
    });

    if (navigator.share) { // if sharing supported
      lightbox.pswp.ui.registerElement({
        name: 'share',
        order: 4,
        isButton: false,
        appendTo: 'root',
        html: '<span class="pswp__share__label">Share</span>',
        onClick: () => {
          $.publish('room_page_interaction', {
            section: 'photos',
            element: 'sharing_button',
            interaction: 'share',
          });

          window.navigator.share({
            title: document.querySelector('.mosaicPopup__title').textContent.trim(),
            url: window.location.href,
          });
        },
      });
    }
  });

  lightbox.on('change', () => {
    $.publish('room_page_interaction', {
      section: 'photos',
      element: 'photo_browser',
      element_value: lightbox.pswp.currIndex,
      interaction: 'show',
    });
  });

  lightbox.init();

  // expose to use within onclick attribute
  window.pswpLightbox = lightbox;
};

const initHistoryHelper = () => {
  // init history helper
  historyHelper = App.components.history_state({
    onChange(popEvent) {
      if (popEvent.state && typeof popEvent.state === 'string' && popEvent.state.indexOf('lightbox-gallery') === 0) {
        const index = +popEvent.state.replace('lightbox-gallery', '');
        window.pswpLightbox.loadAndOpen(index);
      } else if (popEvent?.state === 'mosaic-gallery') {
        mosaicModal.show();

        if (window.pswpLightbox?.pswp?.isOpen) {
          window.pswpLightbox.pswp.close();
        }
      } else {
        mosaicModal.hide();
        if (window.pswpLightbox?.pswp?.isOpen) {
          window.pswpLightbox.pswp.close();
        }
      }
      if (!popEvent.state && window.pswpLightbox?.pswp?.isOpen) {
        window.pswpLightbox.pswp.close();
      }
    },
  });
};

const initMosaic = (roomId, templateSelector) => {
  // template
  const template = document.querySelector(templateSelector).content.cloneNode(true);
  document.body.appendChild(template);

  // init modal
  mosaicModal = new App.views.shared.modal(
    document.querySelector('.mosaicPopup'),
    document.querySelector('.mosaicPopupOverlay'),
    {
      onCloseButtonClick: () => {
        historyHelper.back();
      },
    },
  );

  // images
  const observer = initMosaicLazyLoading();
  document.querySelectorAll('.mosaicPopup__img').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      const index = +e.currentTarget.dataset.index;
      historyHelper.pushState(`lightbox-gallery${index}`, 'Gallery', '#lightbox-gallery');
      window.pswpLightbox.loadAndOpen(index);

      $.publish('room_page_interaction', {
        section: 'photos_mosaic',
        element: 'photo_preview',
        element_value: index,
        interaction: 'click',
      });
    });

    observer.observe(el);
  });

  // like button
  document.querySelectorAll('.mosaicPopup__likeButton').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      App.es6.shared.wish_list.then(api => {
        api.toggleSaved(roomId, { section: 'photos_mosaic' })
          .then((isSaved) => {
            if (isSaved) {
              if (api.isFavourite(roomId)) {
                document.querySelectorAll('.mosaicPopup__likeButton').forEach(a => {
                  a.classList.add('mosaicPopup__likeButton--liked');
                });
              } else {
                document.querySelectorAll('.mosaicPopup__likeButton').forEach(b => {
                  b.classList.remove('mosaicPopup__likeButton--liked');
                });
              }
            }
          });
      });
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') {
      return;
    }
    if (window.pswpLightbox?.pswp?.isOpen || historyHelper.getState() === 'mosaic-gallery') {
      historyHelper.back();
    }
  });

  document.querySelectorAll('.js-gallery-other-rooms-view-space').forEach((el) => {
    el.addEventListener('click', () => {
      const id = el.dataset.roomId;
      $.publish('room_page_interaction', {
        section: 'photo_gallery',
        element: 'view_space_button',
        element_value: id,
        interaction: 'click',
      });
    });
  });
};

const openMosaic = async (roomId) => {
  mosaicModal.show();

  $.publish('room_page_interaction', {
    section: 'photos_mosaic',
    element: 'photo_mosaic',
    interaction: 'show',
  });

  App.es6.shared.wish_list.then(api => {
    if (api.isFavourite(roomId) || window.sessionStorage.getItem(WISHLIST_LOCAL_STORAGE_KEY) === roomId.toString()) {
      document.querySelectorAll('.mosaicPopup__likeButton').forEach(a => {
        a.classList.add('mosaicPopup__likeButton--liked');
      });
    } else {
      document.querySelectorAll('.mosaicPopup__likeButton').forEach(b => {
        b.classList.remove('mosaicPopup__likeButton--liked');
      });
    }
  });
};

export const roomPageMainInit = () => {
  initMobileSlider('roomPage');

  $(document).ready(async () => {
    App.log('roomPage.mainStart');

    const roomData = $('.js-roompage-data').data();
    const roomId = roomData.roomId;

    initHistoryHelper();

    initGallery();
    initMosaic(roomId, '#mosaic-gallery');
    // init3DTourExperiment();

    if (window.location.hash === '#mosaic-gallery') {
      window.history.replaceState(null, null, ' ');
      historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');
      openMosaic(roomId);
    } else if (window.location.hash === '#lightbox-gallery') {
      const index = 0;
      window.history.replaceState(null, null, ' ');
      historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');
      historyHelper.pushState(`lightbox-gallery${index}`, 'Gallery', '#lightbox-gallery');
      window.pswpLightbox.loadAndOpen(index);
    }

    document.querySelectorAll('.gallery-container').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        const id = +e.currentTarget.dataset.id;

        openMosaic(roomId);
        historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');

        const img = document.querySelector(`.mosaicPopup__img[data-id="${id}"]`);
        if (img) {
          img.scrollIntoView({ block: 'center' });
        }
      });
    });

    const allPhotosButton = document.querySelector('.js-all-photos');
    if (allPhotosButton) {
      allPhotosButton.addEventListener('click', (e) => {
        e.preventDefault();

        openMosaic(roomId);
        historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');
      });
    }

    // share Button
    if (navigator.share) { // if sharing supported
      const shareButton = document.querySelector('.mosaicPopup__shareButton');
      shareButton.classList.remove('none');
      shareButton.addEventListener('click', (e) => {
        e.preventDefault();

        $.publish('room_page_interaction', {
          section: 'photos_mosaic',
          element: 'sharing_button',
          interaction: 'share',
        });

        window.navigator.share({
          title: document.querySelector('.mosaicPopup__title').textContent.trim(),
          url: window.location.href,
        });
      });
    }

    App.views.shared.detect_device();
    App.es6.shared.in_view();
    App.components.room_cards_carousel();
    App.components.room_selection_tracking();

    App.views.room.truncate();

    App.es6.shared.wish_list.then(api => {
      api.updateDOMWithState();
    });

    App.es6.views.room.hint_tooltips().init();

    initMap();
    initHeader();
    initPricing();

    initRoomHighlights();

    $('.js-show-all-cancellation-policies').on('click', function () {
      $('.cancellation-policies-block').show();
      $(this).hide();
    });

    $('.js-pricing-update').onIntersection(() => {
      App.track.event('room_page_interaction', {
        ...window.__TGV_GA4_TRACKING,
        section: 'prices',
        element: 'update',
        interaction: 'visible',
      });
    });

    $('.js-pricing-confirmation').onIntersection(() => {
      App.track.event('room_page_interaction', {
        ...window.__TGV_GA4_TRACKING,
        section: 'prices',
        element: 'confirmation',
        interaction: 'visible',
      });
    });

    App.log('roomPage.mainDone');

    // offload main thread a bit
    tryMarkingRoomAsExternallyClicked(roomId);
    initReviewsModal('roomPage');
    initThe3dTourLinks();

    setTimeout(() => {
      clearOldNavigationInteractionsEntries();
      clearOldSimilarRoomsInteractionsEntries();
      clearOldVenuePageInteractionsEntries();
    }, 1000);

    $('.js-venuepage-breadcrumb').on('click', (event) => {
      const type = event.currentTarget.dataset.type;
      const value = event.currentTarget.innerText.trim();

      App.track.event('room_page_interaction', {
        section: 'breadcrumbs',
        element: type,
        element_value: value,
        interaction: 'click',
      });

      App.track.event('clicked_to_location_page', {
        section: 'room_page_breadcrumbs',
        element: type,
        element_value: value,
        interaction: 'click',
      });
    });
  });
};
